module.exports = __webpack_public_path__ + "media/dashboard/assets/images/no_page_image-416118fc189feff0a0012077801d0da0.png";